import create from 'zustand'

interface RegistrationCertificateState {
	selectRegistrationCertificateModalOpened: boolean
	setSelectRegistrationCertificateModalOpened: (
		selectRegistrationCertificateModalOpened: boolean,
	) => void
	registrationCertificate: {
		registrationCertificateId: string
		registrationCertificateNumber: string
	} | null
	setRegistrationCertificate: (registrationCertificate: {
		registrationCertificateId: string
		registrationCertificateNumber: string
	}) => void
}

export const useRegistrationCertificateStore =
	create<RegistrationCertificateState>((set) => ({
		selectRegistrationCertificateModalOpened: false,
		setSelectRegistrationCertificateModalOpened: (
			selectRegistrationCertificateModalOpened: boolean,
		) => {
			set({ selectRegistrationCertificateModalOpened })
		},
		registrationCertificate: null,
		setRegistrationCertificate: (registrationCertificate: {
			registrationCertificateId: string
			registrationCertificateNumber: string
		}) => {
			set({ registrationCertificate })
		},
	}))
